module.exports = __webpack_public_path__ + "img/party-popper.f406a280.svg";